import React, { useMemo } from 'react';
import { CheckCircle, Error } from '@mui/icons-material';
import {
  CircularProgress,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { LoadingScreen, MainButton } from '~components/atoms';
import { useRedeemReward } from '~hooks';
import { useLanguageContext, useMainContext } from '~providers';

export const PromoCodeForm = () => {
  const { lt } = useLanguageContext();

  const { initialComplete } = useMainContext();

  const {
    onChangePromoteCode,
    redeemReward,
    isRedeemRewardLoading,
    promoteCode,
    rewardRedeemError,
    rewardRedeemSuccessMessage,
  } = useRedeemReward();

  const renderEndAdornmentPromotionField = useMemo(() => {
    if (rewardRedeemError) {
      return <Error color="error" fontSize="small" />;
    }
    if (rewardRedeemSuccessMessage) {
      return <CheckCircle color="success" fontSize="small" />;
    }
    return null;
  }, [rewardRedeemError, rewardRedeemSuccessMessage]);

  if (!initialComplete) {
    return <LoadingScreen />;
  }

  return (
    <Stack>
      <Stack>
        <TextField
          autoFocus
          label={lt('placeholder.promoInput', 'Promo Code')}
          error={!!rewardRedeemError}
          onChange={onChangePromoteCode}
          sx={{
            '& input::placeholder': {
              color: '#6A737D',
              fontWeight: 400,
              fontSize: '1rem',
            },
          }}
          InputProps={{
            endAdornment: renderEndAdornmentPromotionField && (
              <InputAdornment position="end">
                {renderEndAdornmentPromotionField}
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      {rewardRedeemError && (
        <Typography variant="Inter/Body-sm" color="error.main" mt={0.5}>
          {rewardRedeemError}
        </Typography>
      )}

      {rewardRedeemSuccessMessage && (
        <Typography variant="Inter/Body-sm" color="success.main" mt={0.5}>
          {rewardRedeemSuccessMessage}
        </Typography>
      )}

      <MainButton
        sx={{ mt: 4 }}
        variant="contained"
        onClick={redeemReward}
        disabled={
          isRedeemRewardLoading || !promoteCode || !!rewardRedeemSuccessMessage
        }
      >
        <Typography variant="Poppins/Subheading-md">
          {isRedeemRewardLoading ? (
            <CircularProgress size="16px" color="inherit" />
          ) : (
            lt('text.apply', 'Apply')
          )}
        </Typography>
      </MainButton>
    </Stack>
  );
};
